import { cn } from "@/lib/utils";

/** Bildmarke: rotes Quadrat mit stilisierter Uhr (Viertelkreis = Zeitspanne). */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn("size-7 shrink-0", className)}>
      <rect width="32" height="32" rx="8" fill="var(--primary)" />
      <circle cx="16" cy="16" r="9" fill="none" stroke="var(--primary-foreground)" strokeWidth="2.4" />
      <path d="M16 16V9.6A6.4 6.4 0 0 1 22.4 16Z" fill="var(--primary-foreground)" />
    </svg>
  );
}

export function Brand({ collapsed = false }: { collapsed?: boolean }) {
  return (
    <div className="flex items-center gap-2.5">
      <BrandMark />
      {!collapsed && <span className="text-[15px] font-semibold tracking-tight">optitime</span>}
    </div>
  );
}
